// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5331":"72aa9cb83116fe75","5584":"63e1e8caf431a6a5","6869":"625b9d16b7f106ed"}[chunkId] + ".js";
};